module.exports = __webpack_public_path__ + "static/017-0b3cd022e4f1b468e3d894033540409b.jpg";